export default __webpack_public_path__ + "static/media/rocket.5de23b37.svg";